let messages = {
  ru: {
    CPR_REVIEW_THX: 'Спасибо за отзыв',
    CPR_REVIEW_MODERATE: 'У нас включена премодерация, поэтому отзывы публикуются после проверки.',
    CPR_CONTACT_DATA: 'Контактные данные',
    CPR_CONTACT_NAME: 'Имя',
    CPR_CONTACT_EMAIL: 'E-mail',
    CPR_CONTACT_OR: 'или',
    CPR_CONTACT_AUTHORIZE: 'авторизируйтесь',
    CPR_INSERT_REVIEW: 'Оставьте свой отзыв',
    CPR_YOUR_RATE: 'Ваша оценка',
    CPR_REVIEW: 'Отзыв',
    CPR_SEND_REVIEW: 'Опубликовать',
  },
  ua: {
    CPR_REVIEW_THX: 'Дякуємо за відгук',
    CPR_REVIEW_MODERATE: 'У нас включена премодерація, тому відгуки публікуються після перевірки.',
    CPR_CONTACT_DATA: 'Контактні дані',
    CPR_CONTACT_NAME: 'Ім\'я',
    CPR_CONTACT_EMAIL: 'E-mail',
    CPR_CONTACT_OR: 'або',
    CPR_CONTACT_AUTHORIZE: 'авторизуйтесь',
    CPR_INSERT_REVIEW: 'Залиште свій відгук',
    CPR_YOUR_RATE: 'Ваша оцінка',
    CPR_REVIEW: 'Відгук',
    CPR_SEND_REVIEW: 'Опублікувати відгук',
  }
}

export default messages